import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';
import * as CurrencyFormat from 'react-currency-format';

class ContributionKsRows extends Component{
    constructor(props){
        super(props)
        this.state = {
            loading: true,
            usrMemberSetId: null
        }
    }

    static getDeriveStateFromProps(props, state){
        return {
            usrMemberSetId: props.match.params.usrMemberSetId
        }
    }

    // makeColumns(){
    //     this.props.futureStrategy.
    // }

    render(){
        const {t} = this.props
        const contributionHolidayEnd = this.props.memberContribution.contributionHolidayEnd;
        return(
            <div  style={{marginTop:"-10px", marginLeft: "10px", fontSize: "12px"}}>
                <p>{t("contribution:kslevels:part1")}<b>{t("contribution:kslevels:part2")}</b>{t("contribution:kslevels:part3")}</p>
                
    
                <table className="table-responsive superlifeLegacyPlan" style={{marginLeft: "10px", marginRight: "1px"}}>
                    <thead  style={{textAlign: "left"}}>
                        <tr>
                            <th style={{width: "45%"}}></th>
                            <th >{t("contribution:amount")}</th>
                            <th >{t("contribution:bankAccount")}</th>
                            <th >{t("contribution:scheduleDate")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.memberContribution.contributionKsRows.map(contribution => 
                            
                            <tr>
                                <td  style={{textAlign: "left"}}>
                                    {contribution.code == 'SAL'? 
                                        <span>{t(`contribution:ks:row:${contribution.code + contribution.description}`)}</span> 
                                        :<span>{contribution.webDesc}</span> //Reconfirm if you should be allowed to edit here
                                    }
                                </td>

                                {!(contribution.code == 'SAL' && contribution.description == 'E') ? 
                                <>
                                    <td>
                                        <span><CurrencyFormat value={Number(contribution.memberAmount).toFixed(2)}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            prefix={'$'} />
                                        </span>
                                    </td>
                                    <td>
                                        {contribution.code.substring(0,2) == 'DD' || contribution.code.substring(0,2) == 'DL' ? 
                                            <span>{contribution.description}</span>
                                            :<></>
                                        }
                                    </td>
                                    <td>
                                        <span>{contribution.memberDate}</span>
                                    </td>
                                </>:<>
                                </>
                                }

                                {(contribution.code == 'SAL' && contribution.description == 'E') ? 
                                <>
                                    <td>
                                        <span><CurrencyFormat value={Number(contribution.employerAmount).toFixed(2)}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            prefix={'$'} />
                                        </span>
                                    </td>
                                    <td>
                                        {contribution.code.substring(0,2) == 'DD' || contribution.code.substring(0,2) == 'DL' ? 
                                            <span>{contribution.description}</span>
                                            :<></>
                                        }
                                    </td>
                                    <td>
                                        <span>{contribution.employerDate}</span>
                                    </td>
                                </>:<>
                                </>
                                }

                            </tr>
                        )}                        
                    </tbody>
                </table>

                {this.props.memberContribution.contributionHoliday ? 
                    <div>
                        <span>{t("contribution:contributionHoliday",{contributionHolidayEnd})}</span>
                    </div>
                    : <></>
                }
            </div>
        )
    }
}
export default withTranslation()(ContributionKsRows);